
export const MASK_COOK_PHONE_NUMBER = true;


export const maskPhoneNumber = (phone: string | undefined | null): string => {
  if (!phone) return phone ?? '';
  if (!MASK_COOK_PHONE_NUMBER) return phone;
  if (phone.length <= 2) return phone;
  return phone.slice(0, 2) + '*'.repeat(phone.length - 2);
};
